<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >

    <b-row>
      <b-col cols="9">
        <b-card title="Installation Data">
          <!-- Device -->
          <b-row>
            <b-col cols="4">
              <b-form-group label="Device" label-for="v-Device">
                <validation-provider #default="{ errors }"  name="Device" rules="required">
                  <v-select readonly id="v-Device" v-model="form.select_1" placeholder="Chose Device" disabled autocomplete="off" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="DeviceOptions" :reduce="DeviceOptions => DeviceOptions.value"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Site -->
            <b-col cols="5">
              <b-form-group label="Site" label-for="v-Site">
                <validation-provider #default="{ errors }"  name="Site" rules="required">
                  <v-select id="v-Site" v-model="form.select_9" placeholder="Chose  Site" autocomplete="off" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="SiteOptions" :reduce="SiteOptions => SiteOptions.value"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group
                label="Installation Date"
              >
                <flat-pickr
                  v-model="form.date_1"
                  class="form-control"
                  :config="{ dateFormat: 'd-m-Y'}"
                  placeholder="DD-MM-YYYY"
                  disabled
                />
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label="Device Type" label-for="v-Device Type">
                <validation-provider #default="{ errors }"  name="Device Type">
                  <b-form-input readonly id="v-Device Type" :state="errors.length > 0 ? false:null" v-model="device_type_name" placeholder="Device Type" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label="Device SN" label-for="v-Device SN">
                <validation-provider #default="{ errors }"  name="Device SN">
                  <b-form-input readonly id="v-Device SN" :state="errors.length > 0 ? false:null" v-model="device_serial_number" placeholder="Device SN" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label="Device Note" label-for="v-Device Note">
                <validation-provider #default="{ errors }"  name="Device Note">
                  <b-form-input readonly id="v-Device Note" :state="errors.length > 0 ? false:null" v-model="device_note" placeholder="Device Note" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <hr>
              <div id="map" style="height: 300px;"></div>
              <hr>
              <b-row>
                <!-- Latitude -->
                <b-col cols="6">
                  <b-form-group label="Latitude" label-for="v-Latitude">
                    <validation-provider #default="{ errors }"  name="Latitude" rules="required">
                      <b-form-input readonly id="v-Latitude" :state="errors.length > 0 ? false:null" v-model="form.text_3" placeholder="Latitude" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- Longtitude -->
                <b-col cols="6">
                  <b-form-group label="Longtitude" label-for="v-Longtitude">
                    <validation-provider #default="{ errors }"  name="Longtitude" rules="required">
                      <b-form-input readonly id="v-Longtitude" :state="errors.length > 0 ? false:null" v-model="form.text_4" placeholder="Longtitude" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <template>
              <b-col cols="12">
                <b-form-group label="Photo" label-for="v-desc" style="display: none;">
                  <br>
                  <b-media no-body>
                    <iframe :src="form.UrlPhoto" width="30%" height="300"/>
                    <b-media-body class="mt-75 ml-75">
                      <!-- upload button -->
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        size="sm"
                        class="mb-75 mr-75"
                        @click="$refs.refInputElPhoto.$el.click()"
                      >
                        Upload
                      </b-button>
                      <b-form-file
                        ref="refInputElPhoto"
                        v-model="form.photo"
                        accept="application/jpg/png/jpeg/JPG/PNG/JPEG"
                        :hidden="true"
                        plain
                        @change="UploadRenderPhoto"
                      />
                      <!--/ upload button -->
                      <b-card-text>Allowed JPG/jpg/PNG/png. Max size of 2000kB</b-card-text>
                    </b-media-body>
                  </b-media>
                </b-form-group>
              </b-col>
              <b-form @submit.prevent>
                <b-col cols="12">
                  <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="submitEdit"> Update </b-button>
                </b-col>
              </b-form>
            </template>
          </b-row>
          <validation-observer ref="simpleRules">
            <b-form @submit.prevent style="display: none;">
              <b-col cols="12" v-if="status === 'VF'">
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Approve </b-button>
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" v-b-modal.modal-center > Approve by Note </b-button>
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="danger" class="mr-1" @click.prevent="validationFormReject"> Reject </b-button>
              </b-col>
            </b-form>
            <b-modal
              id="modal-center"
              ref="my-modal"
              size="xl"
              centered
              title="Aprrove by Note"
              ok-title="Accept"
              @ok="validationFormNotes()"
            >
              <form ref="form">
                <!-- Reason -->
                <div class="mt-2">
                  <b-form-textarea
                    id="textarea-default"
                    placeholder="Note"
                    v-model="form.textarea_1"
                    rows="3"
                  /><br>
                </div>
              </form>
            </b-modal>
          </validation-observer>
        </b-card>
      </b-col>
      <b-col cols="3">
        <b-card title="">
          <!-- <b-card-text>Bank.</b-card-text> -->
          <b-row>
            <b-col cols="12"><div class="h-50 d-inline-block"></div></b-col>
            <!-- Instalator Company -->
            <b-col cols="12" style="display: none;">
              <b-form-group label="Instalator Company" label-for="v-Instalator Company">
                  <b-form-input  id="v-Instalator Company" v-model="form.text_1" placeholder="Instalator Company" />
              </b-form-group>
            </b-col>
            <!-- Instalator Name -->
            <b-col cols="12" style="display: none;">
              <b-form-group label="Instalator Name" label-for="v-Instalator Name">
                  <b-form-input readonly id="v-Instalator Name" v-model="form.text_2" placeholder="Instalator Name" />
              </b-form-group>
            </b-col>
            <!-- Province -->
            <b-col cols="12" style="display: none;">
              <b-form-group label="Province" label-for="v-Province">
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="ProvinceOptions" :reduce="ProvinceOptions => ProvinceOptions.value"
                    id="v-Province" 
                    v-model="select_6" 
                    label="title"
                    placeholder="--Select Province --"
                    class="w-100"
                    readonly
                  />
              </b-form-group>
            </b-col>
            <!-- Regency -->
            <b-col cols="12" style="display: none;">
              <b-form-group label="Regency" label-for="v-Regency">
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="RegencyOptions" :reduce="RegencyOptions => RegencyOptions.value"
                    id="v-Regency" 
                    v-model="select_7" 
                    label="title"
                    placeholder="--Select Regency --"
                    class="w-100"
                    readonly
                  />
              </b-form-group>
            </b-col>
            <!-- District -->
            <b-col cols="12" style="display: none;">
              <b-form-group label="District" label-for="v-District">
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="DistrictOptions" :reduce="DistrictOptions => DistrictOptions.value"
                    id="v-District" 
                    v-model="select_8" 
                    label="title"
                    placeholder="--Select District --"
                    class="w-100"
                    disabled
                  />
              </b-form-group>
            </b-col>
            <!-- Update Interval -->
            <b-col cols="12" style="display: none;">
              <b-form-group
                label="Update Interval"
              >
              <b-input-group>
                <b-form-input readonly type="number" id="v-Update Interval" v-model="form.text_5" placeholder="Update Interval" />
                <b-input-group-append is-text>
                <b>&nbsp;Minute</b>
                </b-input-group-append>
              </b-input-group>
              </b-form-group>
            </b-col>
            <!-- media -->
            <b-col cols="12" style="display: none;">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalUrlInstalasi
                variant="outline-primary"
              >
                Installation Documentation File
              </b-button><hr>
              <b-modal
                id="modalUrlInstalasi"
                title="Installation Documentation File"
                size="xl"
                ok-only
                ok-title="Accept"
              >
                <b-card-text>
                  <b-form-group label="" label-for="v-desc">
                    <br>
                    <b-media no-body>
                      <iframe :src="form.UrlInstalasi" width="100%" height="700"/>

                      <b-media-body class="mt-75 ml-75" style="display:none">
                        <!-- upload button -->
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="$refs.refInputElInstalasi.$el.click()"
                        >
                          Upload
                        </b-button>
                        <b-form-file
                          ref="refInputElInstalasi"
                          v-model="form.instalasi"
                          accept="application/pdf"
                          :hidden="true"
                          plain
                          @change="UploadRenderInstalasi"
                        />
                        <!--/ upload button -->

                        <!-- reset -->
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          variant="outline-secondary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="resetinstalasi"
                        >
                          Reset
                        </b-button>
                        <!--/ reset -->
                        <b-card-text>Allowed PDF. Max size of 2000kB</b-card-text>
                      </b-media-body>
                    </b-media>
                  </b-form-group>
                </b-card-text>
              </b-modal>
            </b-col>
            <b-col cols="12" style="display: none;">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalUrlBast
                variant="outline-primary"
              >
                BAST File
              </b-button><hr>
              <b-modal
                id="modalUrlBast"
                title="BAST File"
                size="xl"
                ok-only
                ok-title="Accept"
              >
                <b-card-text>
                  <b-form-group label="" label-for="v-desc">
                    <br>
                    <b-media no-body>
                      <iframe :src="form.UrlBast" width="100%" height="700"/>

                      <b-media-body class="mt-75 ml-75" style="display:none">
                        <!-- upload button -->
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="$refs.refInputElBast.$el.click()"
                        >
                          Upload
                        </b-button>
                        <b-form-file
                          ref="refInputElBast"
                          v-model="form.bast"
                          accept="application/pdf"
                          :hidden="true"
                          plain
                          @change="UploadRenderBast"
                        />
                        <!--/ upload button -->

                        <!-- reset -->
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          variant="outline-secondary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="resetbast"
                        >
                          Reset
                        </b-button>
                        <!--/ reset -->
                        <b-card-text>Allowed PDF. Max size of 2000kB</b-card-text>
                      </b-media-body>
                    </b-media>
                  </b-form-group>
                </b-card-text>
              </b-modal>
            </b-col>
            <b-col cols="12" style="display: none;">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalUrlKalibrasi
                variant="outline-primary"
              >
              Device Calibration File
              </b-button><hr>
              <b-modal
                id="modalUrlKalibrasi"
                title="Device Calibration File"
                size="xl"
                ok-only
                ok-title="Accept"
              >
                <b-card-text>
                  <b-form-group label="" label-for="v-desc">
                    <br>
                    <b-media no-body>
                      <iframe :src="form.UrlKalibrasi" width="100%" height="700"/>

                      <b-media-body class="mt-75 ml-75" style="display:none">
                        <!-- upload button -->
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="$refs.refInputElKalibrasi.$el.click()"
                        >
                          Upload
                        </b-button>
                        <b-form-file
                          ref="refInputElKalibrasi"
                          v-model="form.kalibrasi"
                          accept="application/pdf"
                          :hidden="true"
                          plain
                          @change="UploadRenderKalibrasi"
                        />
                        <!--/ upload button -->

                        <!-- reset -->
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          variant="outline-secondary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="resetkalibrasi"
                        >
                          Reset
                        </b-button>
                        <!--/ reset -->
                        <b-card-text>Allowed PDF. Max size of 2000kB</b-card-text>
                      </b-media-body>
                    </b-media>
                  </b-form-group>
                </b-card-text>
              </b-modal>
            </b-col>
            <b-col cols="6">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalBastPhoto1
                variant="outline-primary"
              >
              BAST Photo 1
              </b-button>
              <b-modal
                id="modalBastPhoto1"
                title="BAST Photo 1"
                size="xl"
                ok-only
                ok-title="Accept"
              >
                <b-card-text>
                  <b-form-group label="" label-for="v-desc">
                    <br>
                    <b-media no-body>
                      <iframe :src="form.photo_bast_1" width="100%" height="700"/>
                      <b-media-body class="mt-75 ml-75">
                        <!-- upload button -->
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="$refs.refInputElBast1.$el.click()"
                        >
                          Upload
                        </b-button>
                        <b-form-file
                          ref="refInputElBast1"
                          v-model="form.bast_1"
                          accept=".jpg, .png, .jpeg , .JPG , .PNG , .JPEG"
                          :hidden="true"
                          plain
                          @change="UploadRenderBast_1"
                        />
                        <!--/ upload button -->

                        <!-- reset -->
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          variant="outline-secondary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="resetbast_1"
                        >
                          Reset
                        </b-button>
                        <!--/ reset -->
                        <b-card-text>Allowed jpg/png/jpeg/JPG/PNG/JPEG. Max size of 2000kB</b-card-text>
                      </b-media-body>
                    </b-media>
                  </b-form-group>
                </b-card-text>
              </b-modal>
            </b-col>
            <b-col cols="6">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalBastPhoto2
                variant="outline-primary"
              >
              BAST Photo 2
              </b-button>
              <b-modal
                id="modalBastPhoto2"
                title="BAST Photo 2"
                size="xl"
                ok-only
                ok-title="Accept"
              >
                <b-card-text>
                  <b-form-group label="" label-for="v-desc">
                    <br>
                    <b-media no-body>
                      <iframe :src="form.photo_bast_2" width="100%" height="700"/>
                      <b-media-body class="mt-75 ml-75">
                        <!-- upload button -->
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="$refs.refInputElBast2.$el.click()"
                        >
                          Upload
                        </b-button>
                        <b-form-file
                          ref="refInputElBast2"
                          v-model="form.bast_2"
                          accept=".jpg, .png, .jpeg , .JPG , .PNG , .JPEG"
                          :hidden="true"
                          plain
                          @change="UploadRenderBast_2"
                        />
                        <!--/ upload button -->

                        <!-- reset -->
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          variant="outline-secondary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="resetbast_2"
                        >
                          Reset
                        </b-button>
                        <!--/ reset -->
                        <b-card-text>Allowed jpg/png/jpeg/JPG/PNG/JPEG. Max size of 2000kB</b-card-text>
                      </b-media-body>
                    </b-media>
                  </b-form-group>
                </b-card-text>
              </b-modal>
            </b-col>
            <b-col cols="12"><hr></b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalDocPhoto1
                variant="outline-primary"
              >
              FOTO PLANG FASILITAS KESEHATAN
              </b-button><hr>
              <b-modal
                id="modalDocPhoto1"
                title="FOTO PLANG FASILITAS KESEHATAN"
                size="xl"
                ok-only
                ok-title="Accept"
              >
                <b-card-text>
                  <b-form-group label="" label-for="v-desc">
                    <br>
                    <b-media no-body>
                      <iframe :src="form.photo_doc_1" width="100%" height="700"/>
                      <b-media-body class="mt-75 ml-75">
                        <!-- upload button -->
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="$refs.refInputElDoc1.$el.click()"
                        >
                          Upload
                        </b-button>
                        <b-form-file
                          ref="refInputElDoc1"
                          v-model="form.file_documentation_1"
                          accept=".jpg, .png, .jpeg , .JPG , .PNG , .JPEG"
                          :hidden="true"
                          plain
                          @change="UploadRenderDoc_1"
                        />
                        <!--/ upload button -->

                        <!-- reset -->
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          variant="outline-secondary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="resetdoc_1"
                        >
                          Reset
                        </b-button>
                        <!--/ reset -->
                        <b-card-text>Allowed jpg/png/jpeg/JPG/PNG/JPEG. Max size of 2000kB</b-card-text>
                      </b-media-body>
                    </b-media>
                  </b-form-group>
                </b-card-text>
              </b-modal>
            </b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalDocPhoto2
                variant="outline-primary"
              >
              FOTO RUANG TEMPAT INSTALASI
              </b-button><hr>
              <b-modal
                id="modalDocPhoto2"
                title="FOTO RUANG TEMPAT INSTALASI"
                size="xl"
                ok-only
                ok-title="Accept"
              >
                <b-card-text>
                  <b-form-group label="" label-for="v-desc">
                    <br>
                    <b-media no-body>
                      <iframe :src="form.photo_doc_2" width="100%" height="700"/>
                      <b-media-body class="mt-75 ml-75">
                        <!-- upload button -->
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="$refs.refInputElDoc2.$el.click()"
                        >
                          Upload
                        </b-button>
                        <b-form-file
                          ref="refInputElDoc2"
                          v-model="form.file_documentation_2"
                          accept=".jpg, .png, .jpeg , .JPG , .PNG , .JPEG"
                          :hidden="true"
                          plain
                          @change="UploadRenderDoc_2"
                        />
                        <!--/ upload button -->

                        <!-- reset -->
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          variant="outline-secondary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="resetdoc_2"
                        >
                          Reset
                        </b-button>
                        <!--/ reset -->
                        <b-card-text>Allowed jpg/png/jpeg/JPG/PNG/JPEG. Max size of 2000kB</b-card-text>
                      </b-media-body>
                    </b-media>
                  </b-form-group>
                </b-card-text>
              </b-modal>
            </b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalDocPhoto3
                variant="outline-primary"
              >
              FOTO TEMPAT PENYIMPANAN VAKSIN
              </b-button><hr>
              <b-modal
                id="modalDocPhoto3"
                title="FOTO TEMPAT PENYIMPANAN VAKSIN"
                size="xl"
                ok-only
                ok-title="Accept"
              >
                <b-card-text>
                  <b-form-group label="" label-for="v-desc">
                    <br>
                    <b-media no-body>
                      <iframe :src="form.photo_doc_3" width="100%" height="700"/>
                      <b-media-body class="mt-75 ml-75">
                        <!-- upload button -->
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="$refs.refInputElDoc3.$el.click()"
                        >
                          Upload
                        </b-button>
                        <b-form-file
                          ref="refInputElDoc3"
                          v-model="form.file_documentation_3"
                          accept=".jpg, .png, .jpeg , .JPG , .PNG , .JPEG"
                          :hidden="true"
                          plain
                          @change="UploadRenderDoc_3"
                        />
                        <!--/ upload button -->

                        <!-- reset -->
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          variant="outline-secondary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="resetdoc_3"
                        >
                          Reset
                        </b-button>
                        <!--/ reset -->
                        <b-card-text>Allowed jpg/png/jpeg/JPG/PNG/JPEG. Max size of 2000kB</b-card-text>
                      </b-media-body>
                    </b-media>
                  </b-form-group>
                </b-card-text>
              </b-modal>
            </b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalDocPhoto4
                variant="outline-primary"
              >
              FOTO DUS DEVICE
              </b-button><hr>
              <b-modal
                id="modalDocPhoto4"
                title="FOTO DUS DEVICE"
                size="xl"
                ok-only
                ok-title="Accept"
              >
                <b-card-text>
                  <b-form-group label="" label-for="v-desc">
                    <br>
                    <b-media no-body>
                      <iframe :src="form.photo_doc_4" width="100%" height="700"/>
                      <b-media-body class="mt-75 ml-75">
                        <!-- upload button -->
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="$refs.refInputElDoc4.$el.click()"
                        >
                          Upload
                        </b-button>
                        <b-form-file
                          ref="refInputElDoc4"
                          v-model="form.file_documentation_4"
                          accept=".jpg, .png, .jpeg , .JPG , .PNG , .JPEG"
                          :hidden="true"
                          plain
                          @change="UploadRenderDoc_4"
                        />
                        <!--/ upload button -->

                        <!-- reset -->
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          variant="outline-secondary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="resetdoc_4"
                        >
                          Reset
                        </b-button>
                        <!--/ reset -->
                        <b-card-text>Allowed jpg/png/jpeg/JPG/PNG/JPEG. Max size of 2000kB</b-card-text>
                      </b-media-body>
                    </b-media>
                  </b-form-group>
                </b-card-text>
              </b-modal>
            </b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalDocPhoto5
                variant="outline-primary"
              >
              FOTO LETAK PENYIMPANAN GLYCOL
              </b-button><hr>
              <b-modal
                id="modalDocPhoto5"
                title="FOTO LETAK PENYIMPANAN GLYCOL"
                size="xl"
                ok-only
                ok-title="Accept"
              >
                <b-card-text>
                  <b-form-group label="" label-for="v-desc">
                    <br>
                    <b-media no-body>
                      <iframe :src="form.photo_doc_5" width="100%" height="700"/>
                      <b-media-body class="mt-75 ml-75">
                        <!-- upload button -->
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="$refs.refInputElDoc5.$el.click()"
                        >
                          Upload
                        </b-button>
                        <b-form-file
                          ref="refInputElDoc5"
                          v-model="form.file_documentation_5"
                          accept=".jpg, .png, .jpeg , .JPG , .PNG , .JPEG"
                          :hidden="true"
                          plain
                          @change="UploadRenderDoc_5"
                        />
                        <!--/ upload button -->

                        <!-- reset -->
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          variant="outline-secondary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="resetdoc_5"
                        >
                          Reset
                        </b-button>
                        <!--/ reset -->
                        <b-card-text>Allowed jpg/png/jpeg/JPG/PNG/JPEG. Max size of 2000kB</b-card-text>
                      </b-media-body>
                    </b-media>
                  </b-form-group>
                </b-card-text>
              </b-modal>
            </b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalDocPhoto6
                variant="outline-primary"
              >
              FOTO DEVICE TERPASANG
              </b-button><hr>
              <b-modal
                id="modalDocPhoto6"
                title="FOTO DEVICE TERPASANG"
                size="xl"
                ok-only
                ok-title="Accept"
              >
                <b-card-text>
                  <b-form-group label="" label-for="v-desc">
                    <br>
                    <b-media no-body>
                      <iframe :src="form.photo_doc_6" width="100%" height="700"/>
                      <b-media-body class="mt-75 ml-75">
                        <!-- upload button -->
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="$refs.refInputElDoc6.$el.click()"
                        >
                          Upload
                        </b-button>
                        <b-form-file
                          ref="refInputElDoc6"
                          v-model="form.file_documentation_6"
                          accept=".jpg, .png, .jpeg , .JPG , .PNG , .JPEG"
                          :hidden="true"
                          plain
                          @change="UploadRenderDoc_6"
                        />
                        <!--/ upload button -->

                        <!-- reset -->
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          variant="outline-secondary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="resetdoc_6"
                        >
                          Reset
                        </b-button>
                        <!--/ reset -->
                        <b-card-text>Allowed jpg/png/jpeg/JPG/PNG/JPEG. Max size of 2000kB</b-card-text>
                      </b-media-body>
                    </b-media>
                  </b-form-group>
                </b-card-text>
              </b-modal>
            </b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalDocPhoto7
                variant="outline-primary"
              >
              FOTO SERAH TERIMA DUS DEVICE
              </b-button><hr>
              <b-modal
                id="modalDocPhoto7"
                title="FOTO SERAH TERIMA DUS DEVICE"
                size="xl"
                ok-only
                ok-title="Accept"
              >
                <b-card-text>
                  <b-form-group label="" label-for="v-desc">
                    <br>
                    <b-media no-body>
                      <iframe :src="form.photo_doc_7" width="100%" height="700"/>
                      <b-media-body class="mt-75 ml-75">
                        <!-- upload button -->
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="$refs.refInputElDoc7.$el.click()"
                        >
                          Upload
                        </b-button>
                        <b-form-file
                          ref="refInputElDoc7"
                          v-model="form.file_documentation_7"
                          accept=".jpg, .png, .jpeg , .JPG , .PNG , .JPEG"
                          :hidden="true"
                          plain
                          @change="UploadRenderDoc_7"
                        />
                        <!--/ upload button -->

                        <!-- reset -->
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          variant="outline-secondary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="resetdoc_7"
                        >
                          Reset
                        </b-button>
                        <!--/ reset -->
                        <b-card-text>Allowed jpg/png/jpeg/JPG/PNG/JPEG. Max size of 2000kB</b-card-text>
                      </b-media-body>
                    </b-media>
                  </b-form-group>
                </b-card-text>
              </b-modal>
            </b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalDocPhoto8
                variant="outline-primary"
              >
              FOTO ANTENA EXTERNAL / SIGNAL DEVICE
              </b-button><hr>
              <b-modal
                id="modalDocPhoto8"
                title="FOTO ANTENA EXTERNAL / SIGNAL DEVICE"
                size="xl"
                ok-only
                ok-title="Accept"
              >
                <b-card-text>
                  <b-form-group label="" label-for="v-desc">
                    <br>
                    <b-media no-body>
                      <iframe :src="form.photo_doc_8" width="100%" height="700"/>
                      <b-media-body class="mt-75 ml-75">
                        <!-- upload button -->
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="$refs.refInputElDoc8.$el.click()"
                        >
                          Upload
                        </b-button>
                        <b-form-file
                          ref="refInputElDoc8"
                          v-model="form.file_documentation_8"
                          accept=".jpg, .png, .jpeg , .JPG , .PNG , .JPEG"
                          :hidden="true"
                          plain
                          @change="UploadRenderDoc_8"
                        />
                        <!--/ upload button -->

                        <!-- reset -->
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          variant="outline-secondary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="resetdoc_8"
                        >
                          Reset
                        </b-button>
                        <!--/ reset -->
                        <b-card-text>Allowed jpg/png/jpeg/JPG/PNG/JPEG. Max size of 2000kB</b-card-text>
                      </b-media-body>
                    </b-media>
                  </b-form-group>
                </b-card-text>
              </b-modal>
            </b-col>
            <b-col cols="12" style="display: none;">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalPhoto
                variant="outline-primary"
              >
              FOTO SMILE
              </b-button><hr>
              <b-modal
                id="modalPhoto"
                title="FOTO SMILE"
                size="xl"
                ok-only
                ok-title="Accept"
              >
                <b-card-text>
                  <b-form-group label="" label-for="v-desc">
                    <br>
                    <b-media no-body>
                      <iframe :src="photo_smile" width="100%" height="700"/>
                    </b-media>
                  </b-form-group>
                </b-card-text>
              </b-modal>
            </b-col>
            <!--/ media -->
            <!-- submit and reset -->
            <b-col cols="12"><div class="h-50 d-inline-block"></div></b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BInputGroup, BModal, BFormTextarea, BInputGroupAppend, BOverlay, BCol, BFormGroup, BFormCheckbox, BFormInput, BFormFile, BForm, BButton, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BLink, BImg } from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { required } from '@validations'
import { mapState } from 'vuex'
import store from '@/store/index'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
export default {
  components: { vSelect, flatPickr, BInputGroup, BModal, BFormTextarea, BInputGroupAppend, BOverlay, ValidationProvider, ValidationObserver, BCard, BCardText, BRow, BCol, BFormGroup, BFormCheckbox, BFormInput, BFormFile, BForm, BButton, BMedia, BMediaAside, BMediaBody, BLink, BImg },
  directives: { Ripple },
  data () {
    return { 
      form: {id: null, select_1: '',text_1: '',text_2: '',text_3: '',text_4: '',text_5: '',textarea_1: '',date_1: '', select_9: '',
      UrlInstalasi: '', setUpload: 'none', instalasi: null, 
      UrlBast: '', setUpload2: 'none', bast: null,
      UrlPhoto: '', setUploadP: 'none', photo: null,
      UrlKalibrasi: '', setUpload3: 'none', kalibrasi: null,
      photo_bast_1:'', setUploadBast1: 'none', bast_1: null,
      photo_bast_2:'', setUploadBast2: 'none', bast_2: null,
      photo_doc_1:'', setUploadDoc1: 'none', file_documentation_1: null,
      photo_doc_2:'', setUploadDoc2: 'none', file_documentation_2: null,
      photo_doc_3:'', setUploadDoc3: 'none', file_documentation_3: null,
      photo_doc_4:'', setUploadDoc4: 'none', file_documentation_4: null,
      photo_doc_5:'', setUploadDoc5: 'none', file_documentation_5: null,
      photo_doc_6:'', setUploadDoc6: 'none', file_documentation_6: null,
      photo_doc_7:'', setUploadDoc7: 'none', file_documentation_7: null,
      photo_doc_8:'', setUploadDoc8: 'none', file_documentation_8: null},
      select_6: '',select_7: '',select_8: '',
      device_name:'',
      device_serial_number:'',
      device_note:'',
      area_name:'',
      device_type_name:'',
      installator_name:'',
      location_name:'',
      photo_bast_1:'',
      photo_bast_2:'',
      photo_documentation_1:'',
      photo_documentation_2:'',
      photo_documentation_3:'',
      photo_documentation_4:'',
      photo_documentation_5:'',
      photo_documentation_6:'',
      photo_documentation_7:'',
      photo_documentation_8:'',
      photo_smile:'',
      status:'',
      show: false,
      contentData:null,
      geocoder:'',
      required 
    }
  },
  computed: {
    ...mapState({ 
      SiteOptions: state => state.site.options,
      ProvinceOptions: state => state.region.province, 
      RegencyOptions: state => state.region.regency, 
      DistrictOptions: state => state.region.district,
      DeviceOptions: state => state.device.options
    }),
    direction () {
      if (store.state.appConfig.isRTL) {
        this.dir = true
        return this.dir
      }
      this.dir = false
      return this.dir
    }
  },
  watch: {
    select_6 (obj) {
      return this.$store.dispatch('region/regency', obj)
    },
    select_7 (obj) {
      return this.$store.dispatch('region/district', obj)
    },
    select_8 (obj) {
      return this.$store.dispatch('site/getByFilter', obj)
    }
  },
  created () {
    this.$store.dispatch('site/getByNonFilter')
    this.$store.dispatch('region/province')
    this.$store.dispatch('device/getDeviceList')
  },
  methods: {
    initMap(latittute,longtitude) {
      const myLatlng = { lat: latittute, lng: longtitude }
      this.styledMapType = new google.maps.StyledMapType(
        [
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [
              { visibility: 'off' }
            ]
          }
        ],
        { name: 'Styled Map' }
      )
      this.map = new window.google.maps.Map(document.getElementById('map'), {
          zoom: 12,
          center: myLatlng,
        }
      )

      const marker = new google.maps.Marker({
          position: myLatlng,
          map: this.map,
          title: `${this.device_name} 
          <hr> Site Name : ${this.device_name} 
          <br> Device Code : ${this.device_name} 
          `,
          optimized: false,
        })

        // // Add a click listener for each marker, and set up the info window.
        marker.addListener('click', () => {
          infoWindow.close()
          infoWindow.setContent(marker.getTitle())
          infoWindow.open(marker.getMap(), marker)
        })

      infoWindow.open(this.map)
      
      // Configure the click listener.
      this.map.addListener('click', (mapsMouseEvent) => {
        // Close the current InfoWindow.
        this.form.text_3 = mapsMouseEvent.latLng.toJSON().lat
        this.form.text_4 = mapsMouseEvent.latLng.toJSON().lng
        infoWindow.close()

        // Create the search box and link it to the UI element.
        const input = document.getElementById("pac-input")
        const searchBox = new google.maps.places.SearchBox(input)

        map.controls[google.maps.ControlPosition.TOP_LEFT].push(input)

        // Bias the SearchBox results towards current map's viewport.
        map.addListener("bounds_changed", () => {
          searchBox.setBounds(map.getBounds())
        });

        // Create a new InfoWindow.
        infoWindow = new google.maps.InfoWindow({
          position: mapsMouseEvent.latLng,
        })
        this.geocoder = new google.maps.Geocoder()
        this.geocoder.geocode({'location': mapsMouseEvent.latLng}, function(results, status) {
          let resultsData = results[0]
          console.log(resultsData)
          const contentString =
          '<div id="content">' +
          '<div id="siteNotice">' +
          "</div>" +
          '<h1 id="firstHeading" class="firstHeading">'+resultsData.address_components[0].long_name+'</h1>' +
          '<div id="bodyContent">' +
          "<p>"+resultsData.formatted_address+"</p>" +
          "</div>" +
          "</div>"
          // JSON.stringify(mapsMouseEvent.latLng.toJSON(), null, 2)
          infoWindow.setContent(contentString)
        })
        infoWindow.open(this.map)
      })
      // this.map.mapTypes.set('styled_map', this.styledMapType)
      // this.map.setMapTypeId('styled_map')
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          this.$bvModal
          .msgBoxConfirm('Apakah anda yakin?', {
            title: 'Please Confirm', size: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'No', cancelVariant: 'outline-secondary', hideHeaderClose: false, centered: true,
          })
          .then(value => {
            if (value === true){
              const formData = this.form 
              this.$store.dispatch('temperature/formPostPutVerification', formData)
              .then(res => {
                this.notification('Success','CheckIcon','success','You have successfully')
              }, 
              err => {
                this.show = false
                this.notification('Failed','CloseIcon','danger','You have unsuccessful')
              })
            } else {
              this.show = false
              this.notification('Failed','CloseIcon','danger','You have unsuccessful')
            }
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    validationFormNotes () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
          this.$store.dispatch('temperature/formPostPutVerificationNotes', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        }else {
          this.show = false
          // this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    submitEdit () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
          this.$store.dispatch('temperature/formPostPutEdit', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        }else {
          this.show = false
          // this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    validationFormReject () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          this.$bvModal
          .msgBoxConfirm('Apakah anda yakin?', {
            title: 'Please Confirm', size: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'No', cancelVariant: 'outline-secondary', hideHeaderClose: false, centered: true,
          })
          .then(value => {
            if (value === true){
              const formData = this.form 
              this.$store.dispatch('temperature/formPostPutVerificationReject', formData)
              .then(res => {
                this.notification('Success','CheckIcon','success','You have successfully')
              }, 
              err => {
                this.show = false
                this.notification('Failed','CloseIcon','danger','You have unsuccessful')
              })
            } else {
              this.show = false
              this.notification('Failed','CloseIcon','danger','You have unsuccessful')
            }
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('temperature/getByIdInstallation', id).then(data => {
        console.log(data)
        this.form.id = id
        this.form.select_1 = data.device_name
        this.device_name = data.device_name
        this.form.text_1 = data.device_installator_company
        this.form.text_2 = data.device_installator_name
        this.form.text_3 = data.device_latitude
        this.form.text_4 = data.device_longitude
        this.form.text_5 = data.device_update_interval
        this.form.date_1 = data.installation_date 
        this.status = data.installation_status 
        this.device_type_name = data.device_type_name
        this.device_note = data.device_note
        this.device_serial_number = data.device_serial_number
        this.form.select_9 = data.site_id
        this.form.UrlInstalasi = data.file_documentation
        this.form.UrlBast = data.file_bast
        this.form.UrlKalibrasi = data.file_calibration
        this.form.photo_bast_1 = data.photo_bast_1
        this.form.photo_bast_2 = data.photo_bast_2
        this.form.photo_doc_1 = data.photo_documentation_1
        this.form.photo_doc_2 = data.photo_documentation_2
        this.form.photo_doc_3 = data.photo_documentation_3
        this.form.photo_doc_4 = data.photo_documentation_4
        this.form.photo_doc_5 = data.photo_documentation_5
        this.form.photo_doc_6 = data.photo_documentation_6
        this.form.photo_doc_7 = data.photo_documentation_7
        this.form.photo_doc_8 = data.photo_documentation_8
        this.photo_smile = data.photo_smile
        this.show = false
        this.initMap(parseFloat(data.device_latitude), parseFloat(data.device_longitude))
      })
    },
    reset () {
      this.form.select_1 = ''
      this.form.text_1 = ''
      this.form.text_2 = ''
      this.form.text_3 = ''
      this.form.text_4 = ''
      this.form.text_5 = ''
      this.form.date_1 = '' 
      this.form.select_9 = ''
      this.form.UrlInstalasi = ''
      this.form.UrlBast = ''
      this.form.UrlKalibrasi = ''
    },
    resetinstalasi () {
      this.form.UrlInstalasi = ''
    },
    resetbast () {
      this.form.UrlBast = ''
    },
    resetkalibrasi () {
      this.form.UrlKalibrasi = ''
    },
    resetbast_1 () {
      this.form.photo_bast_1 = ''
    },
    resetbast_2 () {
      this.form.photo_bast_2 = ''
    },
    resetdoc_1 () {
      this.form.photo_doc_1 = ''
    },
    resetdoc_2 () {
      this.form.photo_doc_2 = ''
    },
    resetdoc_3 () {
      this.form.photo_doc_3 = ''
    },
    resetdoc_4 () {
      this.form.photo_doc_4 = ''
    },
    resetdoc_5 () {
      this.form.photo_doc_5 = ''
    },
    resetdoc_6 () {
      this.form.photo_doc_6 = ''
    },
    resetdoc_7 () {
      this.form.photo_doc_7 = ''
    },
    resetdoc_8 () {
      this.form.photo_doc_8 = ''
    },
    UploadRenderInstalasi (e) {
      if (this.form.UrlInstalasi) {
        URL.revokeObjectURL(this.form.UrlInstalasi);
      }
      const instalasi = e.target.files[0];
			this.form.instalasi = instalasi
			this.form.setUpload = 'upload'
			this.form.UrlInstalasi = URL.createObjectURL(e.target.files[0])
		},
    UploadRenderBast (e) {
      if (this.form.UrlBast) {
        URL.revokeObjectURL(this.form.UrlBast);
      }
      const bast = e.target.files[0];
			this.form.bast = bast
			this.form.setUpload2 = 'upload'
			this.form.UrlBast = URL.createObjectURL(e.target.files[0])
		},
    UploadRenderPhoto (e) {
      if (this.form.UrlPhoto) {
        URL.revokeObjectURL(this.form.UrlPhoto);
      }
      const photo = e.target.files[0];
			this.form.photo = photo
			this.form.setUploadP = 'upload'
			this.form.UrlPhoto = URL.createObjectURL(e.target.files[0])
		},
    UploadRenderBast_1 (e) {
      if (this.form.photo_bast_1) {
        URL.revokeObjectURL(this.form.photo_bast_1);
      }
      const bast_1 = e.target.files[0];
			this.form.bast_1 = bast_1
			this.form.setUploadBast1 = 'upload'
			this.form.photo_bast_1 = URL.createObjectURL(e.target.files[0])
		},
    UploadRenderBast_2 (e) {
      if (this.form.photo_bast_2) {
        URL.revokeObjectURL(this.form.photo_bast_2);
      }
      const bast_2 = e.target.files[0];
			this.form.bast_2 = bast_2
			this.form.setUploadBast2 = 'upload'
			this.form.photo_bast_2 = URL.createObjectURL(e.target.files[0])
		},
    UploadRenderDoc_1 (e) {
      if (this.form.photo_doc_1) {
        URL.revokeObjectURL(this.form.photo_doc_1);
      }
      const file_documentation_1 = e.target.files[0];
			this.form.file_documentation_1 = file_documentation_1
			this.form.setUploadDoc1 = 'upload'
			this.form.photo_doc_1 = URL.createObjectURL(e.target.files[0])
		},
    UploadRenderDoc_2 (e) {
      if (this.form.photo_doc_2) {
        URL.revokeObjectURL(this.form.photo_doc_2);
      }
      const file_documentation_2 = e.target.files[0];
			this.form.file_documentation_2 = file_documentation_2
			this.form.setUploadDoc2 = 'upload'
			this.form.photo_doc_2 = URL.createObjectURL(e.target.files[0])
		},
    UploadRenderDoc_3 (e) {
      if (this.form.photo_doc_3) {
        URL.revokeObjectURL(this.form.photo_doc_3);
      }
      const file_documentation_3 = e.target.files[0];
			this.form.file_documentation_3 = file_documentation_3
			this.form.setUploadDoc3 = 'upload'
			this.form.photo_doc_3 = URL.createObjectURL(e.target.files[0])
		},
    UploadRenderDoc_4 (e) {
      if (this.form.photo_doc_4) {
        URL.revokeObjectURL(this.form.photo_doc_4);
      }
      const file_documentation_4 = e.target.files[0];
			this.form.file_documentation_4 = file_documentation_4
			this.form.setUploadDoc4 = 'upload'
			this.form.photo_doc_4 = URL.createObjectURL(e.target.files[0])
		},
    UploadRenderDoc_5 (e) {
      if (this.form.photo_doc_5) {
        URL.revokeObjectURL(this.form.photo_doc_5);
      }
      const file_documentation_5 = e.target.files[0];
			this.form.file_documentation_5 = file_documentation_5
			this.form.setUploadDoc5 = 'upload'
			this.form.photo_doc_5 = URL.createObjectURL(e.target.files[0])
		},
    UploadRenderDoc_6 (e) {
      if (this.form.photo_doc_6) {
        URL.revokeObjectURL(this.form.photo_doc_6);
      }
      const file_documentation_6 = e.target.files[0];
			this.form.file_documentation_6 = file_documentation_6
			this.form.setUploadDoc6 = 'upload'
			this.form.photo_doc_6 = URL.createObjectURL(e.target.files[0])
		},
    UploadRenderDoc_7 (e) {
      if (this.form.photo_doc_7) {
        URL.revokeObjectURL(this.form.photo_doc_7);
      }
      const file_documentation_7 = e.target.files[0];
			this.form.file_documentation_7 = file_documentation_7
			this.form.setUploadDoc7 = 'upload'
			this.form.photo_doc_7 = URL.createObjectURL(e.target.files[0])
		},
    UploadRenderDoc_8 (e) {
      if (this.form.photo_doc_8) {
        URL.revokeObjectURL(this.form.photo_doc_8);
      }
      const file_documentation_8 = e.target.files[0];
			this.form.file_documentation_8 = file_documentation_8
			this.form.setUploadDoc8 = 'upload'
			this.form.photo_doc_8 = URL.createObjectURL(e.target.files[0])
		},
    UploadRenderKalibrasi (e) {
      if (this.form.UrlKalibrasi) {
        URL.revokeObjectURL(this.form.UrlKalibrasi);
      }
      const kalibrasi = e.target.files[0];
			this.form.kalibrasi = kalibrasi
			this.form.setUpload3 = 'upload'
			this.form.UrlKalibrasi = URL.createObjectURL(e.target.files[0])
		}
  },
  mounted () {
    // navigator.geolocation.getCurrentPosition((position) => {
      // this.initMap(position.coords.latitude, position.coords.longitude)
    // })
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
      console.log(this.$route.params.id)
    }
  }
}
</script>
<style scoped>
  #map {
    height:600px;
    width: 100%;
  }
</style>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>